<div class="letter_wrapper">
    <app-secure-image class="profile-picture" [class]="{ 'profile-large': profilePublicPage }" *ngIf="fileId"
        [src]="getDefaultProfileImageUrl()" [fileId]="fileId" [circle]="true" [isComment]="true"
        [profilePublicPage]="profilePublicPage"></app-secure-image>
    <div *ngIf="!fileId" [ngStyle]="{
            height: '8em',
            width: '8em',
            'margin-right': '3vw !important',
            'background-color': this.color,
            'border-radius': '50%'
        }" [class]="{ 'profile-large': profilePublicPage }">
        <div class="center_elements" [class]="{ 'profile-large-font': profilePublicPage }">{{ this.letter }}</div>
    </div>
</div>